"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const auth_1 = require("../auth");
const WorkflowRun_1 = require("./WorkflowRun");
exports.WORKFLOW_RUN_ACTION_TYPES = [
    'approvedAndRan',
    'approvalRequested',
    'approvalRejected',
    'paused',
    'noteAdded',
    'cancelled',
    'scheduled',
    'forceRan',
    'updated',
];
let WorkflowRunAction = class WorkflowRunAction extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRunAction.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRunAction.prototype, "targetUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'scheduled' }),
    class_validator_1.IsIn(exports.WORKFLOW_RUN_ACTION_TYPES),
    tslib_1.__metadata("design:type", String)
], WorkflowRunAction.prototype, "type", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => WorkflowRun_1.WorkflowRun),
    typeorm_1.ManyToOne(() => WorkflowRun_1.WorkflowRun, workflowRun => workflowRun.actions, {
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], WorkflowRunAction.prototype, "workflowRun", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.workflowRun),
    tslib_1.__metadata("design:type", Number)
], WorkflowRunAction.prototype, "workflowRunId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], WorkflowRunAction.prototype, "token", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], WorkflowRunAction.prototype, "note", void 0);
WorkflowRunAction = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], WorkflowRunAction);
exports.WorkflowRunAction = WorkflowRunAction;
class WorkflowRunActionEntity extends WorkflowRunAction {
    toString() {
        return `Workflow run event #${this.id}`;
    }
}
exports.WorkflowRunActionEntity = WorkflowRunActionEntity;
//# sourceMappingURL=WorkflowRunAction.js.map